import { IFormNames } from "./LoginForm.types";

export const formNames: IFormNames = {
  phoneNumber: "phoneNumber",
  password: "password",
};
